import { yupHelper } from "lib/helpers";
import constant from "lib/constant/constant";

import {
  alternateEmailSchema,
  firstNameSchema,
  lastNameSchema,
  emailSchema,
  phoneNumberSchema,
  citySchema,
  countrySchema,
  postalCodeSchema,
  provinceCodeSchema,
  streetAddressSchema,
  brandNameSchema,
  brandSlugSchema,
  brandDescriptionSchema,
  bankNameSchema,
  accountNumberSchema,
  sortCodeSchema,
} from "./schema";

const {
  ALTERNATE_EMAIL,
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  PHONE_NUMBER,
  CITY,
  COUNTRY,
  POSTAL_CODE,
  STREET_ADDRESS,
  BRAND_NAME,
  BRAND_SLUG,
  BRAND_DESCRIPTION,
  BANK_NAME,
  ACCOUNT_NUMBER,
  SORT_CODE,
  PROVINCE_CODE,
} = constant;

const { validateValue, handlePromiseError } = yupHelper;

const validate = async (field, value, cms, schema, label) => {
  let promise = "";
  switch (field) {
    case ALTERNATE_EMAIL:
      promise = validateValue(alternateEmailSchema(cms), { alternateEmail: value });
      break;
    case FIRST_NAME:
      promise = validateValue(firstNameSchema(label, cms), { firstName: value });
      break;
    case LAST_NAME:
      promise = validateValue(lastNameSchema(label, cms), { lastName: value });
      break;
    case EMAIL:
      promise = validateValue(emailSchema(label, cms), { email: value });
      break;
    case PHONE_NUMBER:
      promise = validateValue(phoneNumberSchema(label, cms), { phoneNumber: value });
      break;
    case CITY:
      promise = validateValue(citySchema(label, cms), { city: value });
      break;
    case PROVINCE_CODE:
      promise = validateValue(provinceCodeSchema(cms), { provinceCode: value });
      break;
    case COUNTRY:
      promise = validateValue(countrySchema(cms), { country: value });
      break;
    case POSTAL_CODE:
      promise = validateValue(postalCodeSchema(label, cms, schema), { postalCode: value });
      break;
    case STREET_ADDRESS:
      promise = validateValue(streetAddressSchema(label, cms), { streetAddress: value });
      break;
    case BRAND_NAME:
      promise = validateValue(brandNameSchema(label, cms), { brandName: value });
      break;
    case BRAND_SLUG:
      promise = validateValue(brandSlugSchema(label, cms), { slug: value });
      break;
    case BRAND_DESCRIPTION:
      promise = validateValue(brandDescriptionSchema(cms), { description: value });
      break;
    case BANK_NAME:
      promise = validateValue(bankNameSchema(cms), { bankName: value });
      break;
    case ACCOUNT_NUMBER:
      promise = validateValue(accountNumberSchema(cms), { accountNumber: value });
      break;
    case SORT_CODE:
      promise = validateValue(sortCodeSchema(cms), { sortCode: value });
      break;
    default:
      return "";
  }

  return handlePromiseError(promise);
};
export default validate;
